var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Settings", {
    staticClass: "row-settings",
    attrs: {
      region: "left",
      title: _vm.resource("TemplateRowSettings_Settings_Title"),
      tooltip: _vm.tooltip
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("settings-color-picker", {
              attrs: {
                label: _vm.resource("TemplateRowSettings_Settings_Color_Label"),
                value: _vm.color
              },
              on: {
                input: function($event) {
                  return _vm.$emit("change-color", $event)
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }